import styled from "styled-components";

const StylesContainer = styled.div`
  min-width: 1024px;

  header {
    padding: 16px 0;

    h4 {
      color: #131523;
      font-size: 14px;
      margin: unset;
    }
  }

  p {
    line-height: 24px;
    margin: 16px 0;
    max-width: 850px;
  }
`;

export default StylesContainer;
